import React, { useEffect, useRef, useState } from 'react';

// The wallboard layout is tuned for the 960x540 CSS viewport that Silk reports on a 1080p Fire TV.
// Larger or higher-density televisions (for example a 4K LG) host that exact layout in an iframe
// and scale it uniformly, so every size shows the same validated, fully-fitting wallboard.
export const STAGE_WIDTH = 960;
export const STAGE_HEIGHT = 540;
const MIN_STAGE_VIEWPORT = 1100;

export function shouldUseTvStage() {
  const params = new URLSearchParams(window.location.search);
  const tv = window.location.hostname.startsWith('tv.') || window.location.pathname.startsWith('/tv');
  return tv && window === window.top && params.get('stage') !== '0' && window.innerWidth >= MIN_STAGE_VIEWPORT;
}

function fit() {
  return Math.min(window.innerWidth / STAGE_WIDTH, window.innerHeight / STAGE_HEIGHT);
}

export default function TvStage() {
  const frame = useRef(null);
  const [scale, setScale] = useState(fit);

  useEffect(() => {
    const resize = () => setScale(fit());
    const focusFrame = () => frame.current?.focus();
    window.addEventListener('resize', resize);
    window.addEventListener('click', focusFrame);
    window.addEventListener('keydown', focusFrame);
    return () => {
      window.removeEventListener('resize', resize);
      window.removeEventListener('click', focusFrame);
      window.removeEventListener('keydown', focusFrame);
    };
  }, []);

  const params = new URLSearchParams(window.location.search);
  params.set('stage', '1');
  const src = `${window.location.pathname}?${params.toString()}${window.location.hash}`;

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#050914', overflow: 'hidden' }}>
      <iframe
        ref={frame}
        title="Altus Retreats wallboard"
        src={src}
        onLoad={() => frame.current?.focus()}
        style={{
          position: 'absolute',
          left: Math.round((window.innerWidth - STAGE_WIDTH * scale) / 2),
          top: Math.round((window.innerHeight - STAGE_HEIGHT * scale) / 2),
          width: STAGE_WIDTH,
          height: STAGE_HEIGHT,
          border: 0,
          background: '#07101d',
          transform: `scale(${scale})`,
          transformOrigin: '0 0',
        }}
      />
    </div>
  );
}
